import axios from "axios";

async function getProjects() {

    let response=await axios.get('https://tacarmuhendislikapi-gud6cueygca3bjfp.westeurope-01.azurewebsites.net//Taha')
      return response.data;
    
   
}
async function postt(requets) {


let response =await axios.post('https://tacarmuhendislikapi-gud6cueygca3bjfp.westeurope-01.azurewebsites.net//Taha', requets, {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
});
return response;
}


export async function getProjectById(id) {

  let response=await axios.get(`https://tacarmuhendislikapi-gud6cueygca3bjfp.westeurope-01.azurewebsites.net//Taha/${id}`)
  console.log(response.data);
  return response.data;
}

export async function sendEmail(requets) {

  let response=await axios.post('https://tacarmuhendislikapi-gud6cueygca3bjfp.westeurope-01.azurewebsites.net//Taha/SendMail',requets)
  console.log(response.data);
  return response.data;
}

export async function deleteProject(id) {

  let response=await axios.delete(`https://tacarmuhendislikapi-gud6cueygca3bjfp.westeurope-01.azurewebsites.net//Taha/${id}`)
    return response;

}




export async function updateProjectservice(updatedProject) {



let response =await axios.put('https://tacarmuhendislikapi-gud6cueygca3bjfp.westeurope-01.azurewebsites.net//Taha/taha', updatedProject, {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
});
console.log(response);
return response;
}



export default getProjects;
export { postt};